import { Input, Select } from 'antd';
import styled from 'styled-components';

export const PrefixSelector = styled(Select)`
  width: 90px !important;

  .ant-select-selector {
    height: 32px !important;
    padding: 0 8px !important;
    padding-right: 24px !important;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.colors.black3} !important;
    border-right: none !important;
    border-radius: 6px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    background-color: rgba(0, 0, 0, 0.02) !important;

    .ant-select-selection-item {
      padding: 0 !important;
      padding-right: 0 !important;
      text-align: left;
      padding-left: 4px !important;
      font-size: 14px;
      line-height: 30px;
    }

    .ant-select-selection-search {
      position: absolute;
      left: 12px;
      right: 24px;

      .ant-select-selection-search-input {
        height: 30px;
        text-align: left;
      }
    }
  }

  &.ant-select-open .ant-select-selector {
    border-color: ${({ theme }) => theme.colors.green6} !important;
    box-shadow: none !important;

    .ant-select-selection-item {
      opacity: 0.4;
    }
  }

  .ant-select-dropdown {
    border-radius: 6px;
    overflow: hidden;

    .rc-virtual-list-holder {
      max-height: 300px !important;
    }

    .ant-select-item {
      padding: 10px 16px;

      .ant-select-item-option-content {
        width: 100%;

        > div {
          width: 100%;
          display: flex !important;
          align-items: center !important;

          > span:first-child {
            flex-shrink: 0;
            white-space: nowrap;
          }

          > span:last-child {
            flex-shrink: 0;
            white-space: nowrap;
          }
        }
      }

      &.ant-select-item-option-active {
        background-color: ${({ theme }) => theme.colors.green1};
      }

      &.ant-select-item-option-selected {
        background-color: ${({ theme }) => theme.colors.green2};
        font-weight: 500;
      }
    }
  }
`;

export const PhoneNumberInput = styled(Input)`
  flex: 1;
  height: 32px;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left: none !important;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  &:focus,
  &.ant-input-focused {
    border-color: ${({ theme }) => theme.colors.green6};
    box-shadow: none;
  }
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  gap: 0;
  width: 100%;
  position: relative;

  &:focus-within {
    ${PrefixSelector} .ant-select-selector {
      border-color: ${({ theme }) => theme.colors.green6} !important;
    }

    ${PhoneNumberInput} {
      border-color: ${({ theme }) => theme.colors.green6} !important;
    }

    &::after {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      bottom: -2px;
      left: -2px;
      border: 2px solid rgba(10, 187, 135, 0.1);
      border-radius: 8px;
      pointer-events: none;
    }
  }
`;
